var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex flex-column pt-12 pb-6",attrs:{"absolute":!_vm.focusMode,"app":!_vm.focusMode,"padless":""}},[_c('v-divider',{staticClass:"col-12 px-0 mx-0"}),_c('span',{staticClass:"grey--text text--darken-2"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" - "),_c('strong',[_vm._v("UCPA")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }